<template>
  <div class="star-rating">
    <div class="star" v-for="index in 5" :key="index">
      <!-- Полная желтая звезда -->
      <IconRating v-if="index <= Math.floor(rating)" :size="16" class="star-full" />
      <!-- Половинчатая звезда -->
      <IconRatingHalf v-else-if="isHalfStar(index)" :size="16" class="star-half" />
      <!-- Пустая серая звезда -->
      <IconRating v-else :size="16" class="star-empty" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconRating, IconRatingHalf } from '@/features/ui-kit/icons';

interface Props {
  rating?: number;
}

const props = withDefaults(defineProps<Props>(), {
  rating: 0,
});

function isHalfStar(curNumber: number): boolean {
  // Проверяем, является ли текущая позиция позицией половинчатой звезды
  const fullStars = Math.floor(props.rating);
  const fractionalPart = props.rating % 1;

  // Половинчатая звезда показывается, если дробная часть от 0.25 до 0.75
  const hasHalfStar = fractionalPart >= 0.25 && fractionalPart < 0.75;

  return hasHalfStar && curNumber === fullStars + 1;
}
</script>

<style lang="stylus" scoped>
.star-rating
  display flex
  //need to avoid content shifting
  width 90px

  .star
    margin-right 2px

  .star-full
    color #F5A623

  .star-empty
    color #DFE1E6

  .star-half
    color #F5A623
</style>
